export default __webpack_public_path__ + "static/media/Yellow0003.8d6d96e9.png";